import * as React from 'react';
import {ObjectFieldTemplateProps} from 'react-jsonschema-form';

/**
 * This is the default version, as the main version, we list all the items,
 * we don't care about material-ui
 */

export default (props: ObjectFieldTemplateProps) => {
    return (
        <div>
            {props.properties.map(prop => prop.content)}
        </div>
    )
};




// WEBPACK FOOTER //
// ./src/components/schemaform/default-renderer.tsx